import * as React from 'react';
import { ListChecksIcon, BriefcaseIcon, HardHatIcon, RecycleIcon } from '@fronton/icons-react';

export type EntranceDoorsBenefitsStructure = {
  icon: React.ReactNode;
  text: string;
};

export const ENTRANCE_DOORS_BENEFITS_DATA: EntranceDoorsBenefitsStructure[] = [
  {
    icon: (
      <ListChecksIcon strokeWidth={0.85} type="duotone" size="40px" color="var(--secondary-orange_dark)" />
    ),
    text: 'Более 100\u00A0000 успешных\u00A0проектов',
  },
  {
    icon: (
      <BriefcaseIcon strokeWidth={0.85} type="duotone" size="40px" color="var(--secondary-orange_dark)" />
    ),
    text: 'Более 350\u00A0экспертов в\u00A0магазинах по\u00A0всей стране',
  },
  {
    icon: <HardHatIcon strokeWidth={0.85} type="duotone" size="40px" color="var(--secondary-orange_dark)" />,
    text: 'Работаем с\u00A0надёжными производителями напрямую',
  },
  {
    icon: <RecycleIcon strokeWidth={0.85} type="duotone" size="40px" color="var(--secondary-orange_dark)" />,
    text: 'Следим за\u00A0качеством: от\u00A0изготовления до\u00A0установки',
  },
];
